import { StanTooltip } from '@/components';
import { cn } from '@/lib';
import { createIconElement } from '@/lib/utils/createIconElement';
import IconHelp from '@/assets/icons/ic-help-circle.svg';

interface TaxAddressFieldProps {
    addressString: string | null;
    loading: boolean;
    onEdit: () => void;
}

export const TaxAddressField = ({ addressString, loading, onEdit }: TaxAddressFieldProps) => (
    <div>
        <div className='mb-1 flex items-center gap-1'>
            <div className='text-label-sm-bold'>Tax Address</div>
            <StanTooltip
                content='The place where your business is located, or the origin address, may determine where you are required to collect sales tax, VAT, or GST.'
                position='top'
            >
                {createIconElement(IconHelp, { className: 'text-brand-main size-3 cursor-help' })}
            </StanTooltip>
        </div>
        <p className='text-caption-2-regular text-gray mb-2'>This will determine your tax jurisdiction.</p>
        <div
            onClick={!loading ? onEdit : undefined}
            className={cn(
                'border-neutral-disabled bg-neutral-light flex w-full max-w-3xl items-center justify-between rounded-md border px-4 py-2',
                !loading && 'cursor-pointer'
            )}
        >
            <span className={addressString ? 'text-dark' : 'text-gray'}>{addressString || 'Enter Tax Address'}</span>
            <span className='text-brand-main text-label-sm-bold'>Edit</span>
        </div>
    </div>
);
